import { render, staticRenderFns } from "./tour-info.vue?vue&type=template&id=3f45d18b&scoped=true"
import script from "./tour-info.vue?vue&type=script&lang=js"
export * from "./tour-info.vue?vue&type=script&lang=js"
import style0 from "./tour-info.vue?vue&type=style&index=0&id=3f45d18b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f45d18b",
  null
  
)

export default component.exports